export function match(param): boolean {
	return /^([a-z][a-z0-9]*)(-[a-z0-9]+)*$/.test(param);
}
